<template>
    <div class="element-editor">
        <el-form v-if="isShowLeftModel" size="mini" label-position="top" style="height:500px;" class="data-operate">
          <el-row >
              <el-col :span="5">
                <el-form-item label="选择的表单">
                    <TreeSelect
                        :key="loadTimer"
                        ref="treeSelect"
                        :isRead="readOnly"
                        :multiple="false"
                        :modelId="selectedModel.modelId"
                        :sourceOptions="appModelsOptions"
                        @treeSelectChoose="handleSelectForm"
                    />
                </el-form-item>
              </el-col>
              <el-col :span="1"></el-col> 
              <el-col :span="18" style="margin-left: 20px;" >
                <el-form-item label="字段查询条件">
                    <el-tabs type="border-card">
                  <!-- <el-tab-pane label="筛选条件"> -->
                       <div v-if="allconditionFields&&allconditionFields.length>0" class="operate-btns">
                          <el-collapse style="height: 480px; overflow-y: auto;" v-model="activeName" @change="handleChange" accordion>
                              <el-collapse-item
                                  v-for="(conditionField, index) in allconditionFields"
                                  :key="conditionField.id"
                                  :name="index">
                                  <template slot="title" > 
                                      <div class="button-title">
                                          <i class="el-icon-caret-right">【{{conditionField.modelName}}】{{conditionField.name}}</i>
                                          
                                      </div>
                                      <div class="form-item-option" v-if="!isHideSearch">
                                          <i class="el-icon-delete" @click.stop="handleDeleteItem(index)" title="删除"></i>
                                      </div> 
                                  </template>
                                    <el-form size="mini"  :inline="true" label-width="80px" >
                                        <el-row>
                                          <el-col :span="20">
                                            <el-form-item style="margin-left: 18px;" label="查询条件">
                                              <el-radio-group v-model="conditionField.operateType" size="mini" class="operate-type">
                                                <el-radio :label="1">包含</el-radio>
                                                  <el-radio :label="2">等于</el-radio>
                                                  <el-radio :label="3">不等于</el-radio>
                                                  <template v-if="conditionField.type === 'date'">
                                                      <el-radio :label="6">范围</el-radio>
                                                  </template>
                                                  <template v-else>
                                                      <el-radio :label="4">大于等于</el-radio>
                                                      <el-radio :label="5">小于等于</el-radio>
                                                  </template>
                                                  <el-radio :label="7">字段值</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                          </el-col>
                                          <el-col :span="1">
                                            <el-tooltip class="item" effect="dark" content="删除当前查询条件" placement="top">
                                                <el-button v-if="!isHideSearch" icon="el-icon-delete" @click.stop="handleDeleteItem(index)" title="删除" type="danger" circle></el-button>
                                            </el-tooltip>
                                          </el-col>
                                        </el-row>
                                        <el-form-item style="margin-left: 18px;" label="查询内容">
                                            <template v-if="conditionField.type === 'date'">
                                                <template v-if="conditionField.operateType === 6">
                                                    <el-date-picker type="date" v-model="conditionField.conditionValueSdt" :value-format="formatField(conditionField)" :format="formatField(conditionField)" :editable="true" placeholder="开始时间" style="width: 100%;"></el-date-picker>
                                                    <el-date-picker type="date" v-model="conditionField.conditionValueEdt" :value-format="formatField(conditionField)" :format="formatField(conditionField)" :editable="true" placeholder="结束时间" style="width: 100%;"></el-date-picker>
                                                </template>
                                                <template v-else>
                                                      <el-date-picker type="date" v-model="conditionField.conditionValue" :value-format="formatField(conditionField)" :format="formatField(conditionField)" :editable="true" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                                                </template>
                                            </template>
                                            <!-- <template v-else-if="conditionField.type === 'date'">
                                                    <el-date-picker v-if="fieldSubType === 'date'" type="date" v-model="formField" value-format="yyyy-MM-dd" :editable="false" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                                                    <el-date-picker v-if="fieldSubType === 'dateTime'" type="datetime" v-model="formField" value-format="yyyy-MM-dd HH:mm:ss" :editable="false" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                                            </template> -->
                                            <template v-else>
                                              <SearchConditionFieldItem  :key="conditionField.id" :field="conditionField" :formData="formData" />
                                            </template>
                                        </el-form-item>
                                        <el-form-item v-if="conditionField.type === 'text' || conditionField.type === 'date' || conditionField.type === 'calculation' || conditionField.type === 'subFormSummary' || conditionField.type === 'serialNumber' || conditionField.type === 'number'" label="排序">
                                            <el-select clearable v-model="conditionField.orderByRule"  placeholder="请选择">
                                                <el-option label="不排序" value=''></el-option>
                                                <el-option label="升序" value='ASC'></el-option>
                                                <el-option label="降序" value='DESC'></el-option>
                                            </el-select>
                                        </el-form-item>
                                      </el-form>
                              </el-collapse-item>
                          </el-collapse>
                          <!-- <el-button type="text" icon="el-icon-circle-plus-outline" plain @click="handleButtonAdd">添加筛选条件</el-button> -->
                      </div>
                    <!-- </el-tab-pane> -->
                    </el-tabs>
                </el-form-item>
              </el-col>
          </el-row>
        </el-form>
        <el-tabs v-if="!isShowLeftModel"  type="border-card">
          <div v-if="allconditionFields&&allconditionFields.length>0" class="operate-btns">
            <el-collapse style="height: 480px; overflow-y: auto;" v-model="activeName" @change="handleChange" accordion>
                  <el-collapse-item
                      v-for="(conditionField, index) in allconditionFields"
                      :key="conditionField.id"
                      :name="index">
                      <template slot="title" >
                          <div class="button-title">
                            <i class="el-icon-caret-right">【{{conditionField.modelName}}】{{conditionField.name}}</i>
                            
                        </div>
                        <div class="form-item-option" v-if="!isHideSearch">
                            <i class="el-icon-delete" @click.stop="handleDeleteItem(index)" title="删除"></i>
                        </div> 
                    </template>
                      <el-form size="mini" label-width="80px" class="button-props">
                        <el-form-item  label="查询条件">
                          <el-radio-group v-model="conditionField.operateType" size="mini" class="operate-type" @change="changeSearchWay">
                            <el-radio :label="1">包含</el-radio>
                              <el-radio :label="2">等于</el-radio>
                              <el-radio :label="3">不等于</el-radio>
                              <template v-if="conditionField.type === 'date'">
                                  <el-radio :label="6">范围</el-radio>
                              </template>
                              <template v-else>
                                  <el-radio :label="4">大于等于</el-radio>
                                  <el-radio :label="5">小于等于</el-radio>
                              </template>
                              <el-radio :label="7">字段值</el-radio>
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item   label="查询内容">
                              <template v-if="conditionField.type === 'date'">
                                  <template v-if="conditionField.operateType === 6">
                                      <el-date-picker type="date" v-model="conditionField.conditionValueSdt" :value-format="formatField(conditionField)" :format="formatField(conditionField)" :editable="true" placeholder="开始时间" style="width: 100%;"></el-date-picker>
                                      <el-date-picker type="date" v-model="conditionField.conditionValueEdt" :value-format="formatField(conditionField)" :format="formatField(conditionField)" :editable="true" placeholder="结束时间" style="width: 100%;"></el-date-picker>
                                  </template>
                                  <template v-else>
                                        <el-date-picker type="date" v-model="conditionField.conditionValue" :value-format="formatField(conditionField)" :format="formatField(conditionField)" :editable="true" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                                  </template>
                              </template>
                              <template v-else-if="conditionField.operateType=== 7">
                                  <el-select v-model="conditionField.valueFieldId" placeholder="请选择">
                                        <el-option
                                        v-for="item in allFields"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                  </el-select>
                              </template>
                              <template v-else>
                                <SearchConditionFieldItem  :key="conditionField.id" :field="conditionField" :multiple="true" :formData="formData" />
                              </template>
                          </el-form-item>
                          <el-form-item v-if="conditionField.type === 'text' || conditionField.type === 'date' || conditionField.type === 'calculation' || conditionField.type === 'subFormSummary' || conditionField.type === 'serialNumber' || conditionField.type === 'number'" label="排序">
                            <el-select clearable v-model="conditionField.orderByRule"  placeholder="请选择">
                                <el-option label="不排序" value=''></el-option>
                                <el-option label="升序" value='ASC'></el-option>
                                <el-option label="降序" value='DESC'></el-option>
                            </el-select>
                         </el-form-item>
                        </el-form>
                  </el-collapse-item>
              </el-collapse>
            </div>
          </el-tabs>
    </div>

</template>
<script>
    import SearchConditionFieldItem from './SearchConditionFieldItem';
    import TreeSelect from '@/components/TreeSelect';
    import { isEmpty, cloneDeep } from 'lodash';
    import { getApplicationModelTreeList, getFormConfig } from '@/data-model';
    export default {
        components: {
            SearchConditionFieldItem,
            TreeSelect
        },
        data () {
            return {
                activeName: 0,
                allconditionFields: [],
                formData: {},
                appModelsOptions: [],
                loadTimer: ''
                // modelId: ''
            };
        },
        props: {
            conditionFields: {
                type: Array
            },
            timeSettingFields: {
                type: Array
            },
            isHideSearch: {
                type: Boolean,
                default: false
            },
            readOnly: {
                type: Boolean,
                default: true
            },
            selectedModel: {
                type: Object,
                default: function () {
                    return {
                        formId: '',
                        modelId: ''
                    };
                }
            },
            isShowLeftModel: {
                type: Boolean,
                default: true
            },
            allFields: {
                type: Array
            },
            multiple: {
                type: Boolean,
                default: false
            },
            currentColumn: {
                type: Object
            }
        },
        computed: {
            treeRoot () {
                // if (this.field.options.config.type === 'single' ||  this.field.type === 'serialNumber') {
                //     if (this.field.options.config.options[0]) {
                //         return {
                //             id: (this.field.options.config.options[0].value),
                //             label: this.field.options.config.options[0].title
                //         };
                //     } else {
                //         return {};
                //     }
                // }
            }
        },
        created () {
            // console.log(this.conditionFields);
            this.allconditionFields = this.conditionFields;
            this.keyupSubmit();// 回车键捕捉事件
            this.getApplicationModelTreeList();
        },
        methods: {
            handleDeleteItem (index) {
                this.allconditionFields.splice(index, 1);
            },
            getSearchCondition () {
                return this.allconditionFields;
            },
            getTimeSettingFields () {
                return this.allconditionFields;
            },
            handleChange (val) {
                // console.log(val);
            },
            setTreeSelect () {
                if (!isEmpty(this.conditionFields)) {
                    let selectedModelId;
                    let selectedFormId;
                    for (let i = 0; i < this.conditionFields.length; i++) {
                        let conditionField = this.conditionFields[i];
                        if (conditionField.modelId) {
                            selectedModelId = conditionField.modelId;
                            selectedFormId = conditionField.formId;
                            break;
                        }
                    }
                    this.selectedModel.modelId = selectedModelId;
                    this.selectedModel.formId = selectedFormId;
                    this.loadTimer = new Date().getTime();
                    // setTimeout(() => { // 多选
                    //     let selectedTree = [];
                    //     selectedTree.push(selectedModelId);
                    //     if (this.$refs.treeSelect) {
                    //         this.$refs.treeSelect.initParam(selectedTree);
                    //     }
                    //     // this.isRead = true;
                    //     this.loadTimer = new Date().getTime();
                    // }, 0);
                }
            },
            async getApplicationModelTreeList () {
                let modelTree = await getApplicationModelTreeList({
                    currentPage: 1,
                    pageSize: 100,
                    state: 1,
                    modelType: 0
                });
                if (modelTree) {
                    this.appModelsOptions = modelTree;
                    this.setTreeSelect();
                }
            },
            keyupSubmit () { // 回车搜索
                let that = this;
                document.onkeypress = function (e) {
                    var keycode = document.all ? window.event.keyCode : e.which;
                    if (keycode === 13) {
                        if (!isEmpty(that.allconditionFields)) {
                            that.chooseSearchConditon();
                        } else if (!isEmpty(that.timeSettingFields)) {
                            that.chooseTimeSettingFields();
                        }
                        return false;
                    }
                };
            },
            chooseSearchConditon () {
                this.$emit('chooseSearchConditon', this.currentColumn);
            },
            chooseTimeSettingFields () {
                this.$emit('chooseTimeSettingFields');
            },
            async handleSelectForm (selectObj) {
                if (selectObj.children) {
                    this.$message({message: '请选择表单节点', type: 'warning'});
                } else {
                    let selectedModel = cloneDeep(selectObj);
                    if (Array.isArray(selectedModel)) { // 多选
                    } else { // 单选
                        const { fieldsList } = await getFormConfig(selectedModel.formId);
                        this.allconditionFields = cloneDeep(fieldsList);
                        this.conditionFields.length = 0;
                        for (let i = 0; i < this.allconditionFields.length; i++) {
                            this.allconditionFields[i].operateType = 1;
                            this.conditionFields.push(cloneDeep(this.allconditionFields[i]));
                        }
                        this.selectedModel.formId = selectedModel.formId;
                        this.selectedModel.modelId = selectedModel.modelId;
                        this.keyupSubmit();// 回车键捕捉事件
                        this.loadTimer = new Date().getTime();
                    }
                }
            },
            changeSearchWay () {
    
            },
            formatField (obj) {
                if (!obj.options.ext3 || obj.options.ext3 === '') {
                    return 'yyyy-MM-dd';
                } else if (obj.options.ext3 === '1') {
                    return 'yyyy-MM';
                } else if (obj.options.ext3 === '2') {
                    return 'yyyy';
                }
            }
        }
    };
</script>


<style lang="less">
  .element-editor {
      /* border: 1px solid #e6e6e6; */
      height: 96%;
      /* overflow-y: auto; */
      margin-top: -20px;
      .exec-type {
        .el-radio+.el-radio {
          margin-left: 0; 
        }
      }
    .el-tabs{
        height: auto;
        .operate-btns {
            display: flex;
            flex-direction: column;

            .el-collapse {
                border-left: 1px solid #ebeef5;
                border-right: 1px solid #ebeef5;
            }

            .button-title {
                padding: 0 0 0 10px;
                flex: 1;
            }

            .form-item-option {
                // position: absolute;
                width: 10px;
                right: 50px;
                cursor: pointer;
                display: block;
            }


            .button-list {
                display: flex;
                flex-direction: column;
            }
            .button-props {
                width: 600px;
            }
            .el-collapse-item{
                .el-collapse-item__wrap{
                    overflow: auto;
                }
            }
        }
    }
    .el-col-18{
         @media screen and (min-width: 1024px) and (max-width: 1366px) {
            width: 70%;
          }
    }
    .el-collapse{
          @media screen and (min-width: 1024px) and (max-width: 1366px) {
            height: 360px !important;
          }
    }
  }
  .field-item-link-pop-search{
      height: 90vh;
      width: 70%;
      .el-dialog__body{
          height: 68vh;
          @media screen and (min-width: 1024px) and (max-width: 1366px) {
            height: 65vh;
            padding-bottom: 6px;
          }
          /* overflow: auto; */
      }
      .dialog-footer{
         @media screen and (min-width: 1024px) and (max-width: 1366px) {
            width: 100%;
            display: inline-block
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchCondition/SearchCondition.vue